
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center">
        <h1 className="text-8xl font-light mb-6">404</h1>
        <p className="text-2xl text-gray-600 mb-8">העמוד שחיפשת לא נמצא</p>
        <p className="text-gray-500 mb-8 max-w-md mx-auto">
          ייתכן שהעמוד הוסר, שונה שמו, או שאינו זמין באופן זמני.
        </p>
        <Link to="/">
          <Button className="bg-black text-white hover:bg-gray-800">
            חזרה לדף הבית
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
